import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var NewChatFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02 0h26.058c5.011 0 9.02 4.011 8.92 9.025v13.737c0 .802 0 1.605-.2 2.306v.201c-1.103 4.914-5.513 8.624-10.724 8.624h-2.506c-.4 0-.802.1-1.203.3-.3.1-.5.201-.701.402L18.44 43.519c-1.303 1.103-3.407.2-3.407-1.604V36.7c0-1.704-1.404-3.008-3.007-3.008H9.02A8.985 8.985 0 0 1 0 24.667V9.025A8.985 8.985 0 0 1 9.02 0ZM22 7a1 1 0 0 0-1 1v8h-8a1 1 0 1 0 0 2h8v8a1 1 0 1 0 2 0v-8h8a1 1 0 1 0 0-2h-8V8a1 1 0 0 0-1-1Z"
  }));
});
NewChatFill.displayName = 'NewChatFill';
NewChatFill.defaultProps = {
  'aria-label': 'NewChatFill'
};
export default NewChatFill;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/NewChatFill.js
// module id = 3226
// module chunks = 11